/**
 * form
 */

import $ from 'jquery';
import Page from '~/page/page';

export default class Form extends Page {
  init() {
    this.state = {};
    this.param = {};

    this.elements({
      button: '.js-form-button'
    });
  }
  events() {
    this.$.root.on('keyup', e => this.handler(e));
  }
  handler(e) {
    e.preventDefault();

    const url = this.$.root.data('validateUrl');

    $.ajax(url)
      .then(({ valid }) => {
        if (valid) {
          this.enableButton();
        }
      })
      .fail(err => {
        console.log(err);
      });
  }
  enableButton() {
    this.$.button.prop('disabled', false);
  }
  disableButton() {
    this.$.button.prop('disabled', true);
  }
}

Page.mount(Form, '.js-form');
